import React, { useState } from "react";
import { Desktop, Tablet } from "../../constants/responsive";
import { css } from "@emotion/core";
import FormBand from "../../svgs/banner-band-flipped.svg";
import { FormattedHTMLMessage, useIntl } from "gatsby-plugin-intl";
import Button from "../Button";
import Container from "../Container";
import { useAppContext } from "../../context/AppContext";
import Check from "../../svgs/check.svg";
import Axios from "axios";

const errorMessages = {
  en: {
    missingName: "Please enter your name",
    missingCompany: "Please enter your company",
    missingEmail: "Please enter your email",
    invalidEmail: "Invalid email",
    missingPhone: "Please enter your phone number",
    invalidPhone: "Invalid phone number",
  },
  "zh-cn": {
    missingName: "请输入姓名",
    missingCompany: "请输入公司",
    missingEmail: "请输入电邮",
    invalidEmail: "电邮格式错误，请重新输入",
    missingPhone: "请输入电话",
    invalidPhone: "电话格式错误，请重新输入",
  },
  "zh-hk": {
    missingName: "請輸入姓名",
    missingCompany: "請輸入公司",
    missingEmail: "請輸入電郵",
    invalidEmail: "電郵格式錯誤，請重新輸入",
    missingPhone: "請輸入電話",
    invalidPhone: "電話格式錯誤，請重新輸入",
  },
};

const Input = ({
  type = "text",
  placeholder,
  onChange = () => {},
  errorMessage = "",
}) => {
  return (
    <div
      css={css`
        position: relative;
      `}
    >
      <input
        css={css`
          width: 100%;
          height: 60px;
          border-radius: 30px;
          padding: 0px 30px;
          background: white;
          font-weight: bold;
          color: black;
          margin-bottom: 10px;
          &::placeholder {
            color: #14123c;
          }
        `}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
      />
      <div
        css={css`
          font-size: 12px;
          line-height: 12px;
          height: 12px;
          color: #ff5252;
          margin-left: 30px;
          margin-bottom: 20px;
        `}
      >
        {errorMessage}
      </div>
    </div>
  );
};

const ProfessionalInvestorsForm = () => {
  const intl = useIntl();

  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [company, setCompany] = useState("");
  const [companyError, setCompanyError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [success, setSuccess] = useState(false);

  const resetError = () => {
    setNameError("");
    setCompanyError("");
    setEmailError("");
    setPhoneError("");
  };

  const {
    professionalInvestorsFormRef,
    setErrorCode,
    apiUrl,
  } = useAppContext();
  return (
    <div
      ref={professionalInvestorsFormRef}
      css={css`
        width: 100%;
        margin-top: 80px;
        ${Desktop} {
          margin-top: 160px;
        }
      `}
    >
      <div
        css={css`
          height: 25px;
          width: 100%;
          min-width: 320px;
          * {
            fill: #14123c;
          }
          ${Tablet} {
            height: 40px;
          }
          ${Desktop} {
            height: 70px;
          }
        `}
      >
        <FormBand width="100%" height="100%" />
      </div>
      <div
        css={css`
          background: #14123c;
          display: flex;
          flex-direction: column;
          align-items: center;
        `}
      >
        <h2
          css={css`
            color: white;
            text-align: center;
            margin-top: 40px;
            ${Tablet} {
              margin-top: 40px;
            }
            ${Desktop} {
              margin-top: 20px;
            }
          `}
        >
          <FormattedHTMLMessage id="professional-investors.form.title" />
        </h2>
        {success ? (
          <div
            css={css`
              text-align: center;
              color: white;
              max-width: 600px;
            `}
          >
            <Check
              css={css`
                width: 36px;
                height: 36px;
                margin-bottom: 20px;
                * {
                  fill: white;
                }
                margin-top: 40px;
                ${Desktop} {
                  width: 60px;
                  height: 60px;
                  margin-top: 100px;
                  margin-bottom: 30px;
                }
              `}
            />
            <h2
              css={css`
                margin-bottom: 40px;
                ${Desktop} {
                  margin-bottom: 100px;
                }
                display: block;
              `}
            >
              {
                {
                  en: (
                    <span>
                      Thank you for contacting us.
                      <br />
                      We will be in touch with you shortly.
                    </span>
                  ),
                  "zh-cn": "提交成功，我们会尽快与您联系。",
                  "zh-hk": "提交成功，我們會盡快與您聯繫。",
                }[intl.locale]
              }
            </h2>
          </div>
        ) : (
          <>
            <div
              css={css`
                font-size: 16px;
                font-weight: bold;
                text-align: center;
                color: white;
                margin-bottom: 40px;
              `}
            >
              <FormattedHTMLMessage id="professional-investors.form.email" />:
              aim@magnumwm.com
            </div>
            <div
              css={css`
                width: 100%;
                padding: 0px 20px;
                max-width: 514px;
              `}
            >
              <Input
                onChange={(e) => {
                  setName(e.target.value);
                }}
                errorMessage={nameError}
                placeholder={intl.formatMessage({
                  id: "professional-investors.form.name",
                })}
              />
              <Input
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
                errorMessage={companyError}
                placeholder={intl.formatMessage({
                  id: "professional-investors.form.company",
                })}
              />
              <Input
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                errorMessage={emailError}
                placeholder={intl.formatMessage({
                  id: "professional-investors.form.email",
                })}
              />
              <Input
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
                errorMessage={phoneError}
                placeholder={intl.formatMessage({
                  id: "professional-investors.form.phone",
                })}
              />
              <div
                css={css`
                  display: flex;
                `}
              >
                <Button
                  disabled={loading}
                  onClick={async () => {
                    setLoading(true);
                    resetError();
                    let error = false;
                    if (!name) {
                      error = true;
                      setNameError(errorMessages[intl.locale]["missingName"]);
                    }
                    if (!company) {
                      error = true;
                      setCompanyError(
                        errorMessages[intl.locale]["missingCompany"]
                      );
                    }
                    if (!email) {
                      error = true;
                      setEmailError(errorMessages[intl.locale]["missingEmail"]);
                    } else if (
                      !/^[A-Z0-9._%+-]{1,30}@[A-Z0-9.-]{1,50}\.[A-Z]{2,10}$/i.test(
                        email
                      )
                    ) {
                      error = true;
                      setEmailError(errorMessages[intl.locale]["invalidEmail"]);
                    }
                    if (!phone) {
                      error = true;
                      setPhoneError(errorMessages[intl.locale]["missingPhone"]);
                    } else if (
                      !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/.test(phone)
                    ) {
                      error = true;
                      setPhoneError(errorMessages[intl.locale]["invalidPhone"]);
                    }
                    if (!error) {
                      const response = await Axios.post(
                        `${apiUrl}/api/v4/users/orgs/contact`,
                        {
                          type: 1,
                          name,
                          company,
                          email,
                          phone,
                        }
                      );
                      if (response.data.status.ecode) {
                        setErrorCode(response.data.status.ecode);
                      } else {
                        setSuccess(true);
                      }
                    }
                    setLoading(false);
                  }}
                >
                  {loading ? (
                    {
                      en: "Submitting...",
                      "zh-cn": "提交中...",
                      "zh-hk": "提交中...",
                    }[intl.locale]
                  ) : (
                    <FormattedHTMLMessage id="institutions.form.submit" />
                  )}
                </Button>
              </div>
            </div>
          </>
        )}

        <Container>
          <div
            css={css`
              width: 100%;
              height: 3px;
              background: white;
              margin-top: 30px;
            `}
          ></div>
        </Container>
      </div>
    </div>
  );
};
export default ProfessionalInvestorsForm;
